import dimensionsJson from './dimensions.json';
import { svgs } from './icons';

export * from './icons';

export type SvgType = (typeof svgs)[number];

const getSize = (viewBox: string): { width: number; height: number } => {
  const [wmin, hmin, wmax, hmax] = (viewBox || '').split(' ');
  return { width: parseFloat(wmax) - parseFloat(wmin), height: parseFloat(hmax) - parseFloat(hmin) };
};

export const dimensions = svgs.reduce((accumulator, svg) => {
  const entry = dimensionsJson.find(({ id }) => id === svg);
  if (!entry) {
    // Optionally, log a warning for missing dimensions
    console.warn(`No dimensions found for SVG: ${svg}`);
    return accumulator;
  }
  return { ...accumulator, [svg]: getSize(entry.viewBox) };
}, {}) as Record<SvgType, { width: number; height: number }>;
